import HelloSign from 'hellosign-embedded'
import { useEffect } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import Loader from '../Loader/Loader'

interface Props {
  onSign: () => void
}

const hellosign = new HelloSign({
  // View requests here: https://app.hellosign.com/apidashboard#/
  clientId: process.env.REACT_APP_HELLO_SIGN_CLIENT_ID,
})

const DocumentView = ({ onSign }: Props) => {
  const data = useSelector((state: RootStateOrAny) => state.document)

  useEffect(() => {
    if (!data.loading) {
      const url = data.signature_request.sign_url
      hellosign.open(url, {
        skipDomainVerification: process.env.NODE_ENV === 'development',
        container: document.getElementById('embed-location')!,
      })

      hellosign.on('sign', onSign)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <div
      id="embed-location"
      className="m-b-16"
      style={{ height: 'calc(100vh - 323px)', position: 'relative' }}
    >
      {data.loading && <Loader />}
    </div>
  )
}

export default DocumentView
